import React, { useEffect, useState } from "react";
import "./HomeCollectionCss/AddressForm.css";
import { useNavigate } from "react-router-dom";
import { convertToMMDDYYYY, formatDate, formatScheduleDate, formatDobDisplay, showFieldError } from "../../utils/helper";
import { useFormik } from "formik";
import * as Yup from "yup";
import ModalWithMap from "./ModalWithMap";
import { FaLocationCrosshairs } from "react-icons/fa6";
import useValidateForm from "../../Hooks/useValidateForm";
import { AiOutlineUser, AiOutlineMail, AiOutlineMobile } from "react-icons/ai";
import { FiMale, FiFemale, FiCalendar } from "react-icons/fi";
import { FaUser, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { MdDateRange } from "react-icons/md";
import { IoMaleFemale } from "react-icons/io5";

const AddressForm = ({
  formData,
  setFormData,
  setFormValid,
  onEditProfile,
  handleChange,
  allFieldsTouched,
  setAllFieldsTouched,
  currentLocation,
  setCurrentLocation
}) => {
  const navigate = useNavigate();
  const [touchedFields, setTouchedFields] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [currentLocation, setCurrentLocation] = useState({
  //   lat: 22.5754,
  //   lng: 88.4791,
  //   selected: false,
  // });

  const addressSchema = Yup.object({
    address: Yup.string().required("Address is required"),
    City: Yup.string().required("City is required"),
    State: Yup.string().required("State is required"),
    Zipcode: Yup.string()
      .matches(/^[0-9]{6}$/, "Pincode must be exactly 6 digits")
      .required("Pincode is required"),
    landmark: Yup.string().nullable(),
  });

  const { isValid, fieldErrors } = useValidateForm(formData, addressSchema);
  useEffect(() => {
    setFormValid(isValid);
  }, [isValid]);  

  // ✅ Formik setup
  // const formik = useFormik({
  //   initialValues: {
  //     address: formData.address || "",
  //     state: formData.state || "West Bengal",
  //     city: formData.city || "Kolkata",
  //     Zipcode: formData.Zipcode || "",
  //     landmark: formData.landmark || "",
  //   },
  //   validationSchema,
  //   validateOnMount: true,
  //   onSubmit: (values) => {
  //     setFormData({ ...formData, ...values });
  //     console.log("Address data saved ✅", values);
  //     // navigate("/next-step") // if needed
  //   },
  // });
  // useEffect(() => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     ...formik.values,
  //   }));
  // }, [formik.values, setFormData]);

  // useEffect(() => {
  //   setFormValid(formik.isValid);
  // }, [formik.isValid]);

  const handleLocationClick = () => {
    setIsModalOpen(true);
  };

  const handleLocationConfirm = (coords) => {
    setCurrentLocation({ ...coords, selected: true });
    setFormData((prev) => ({
      ...prev,
      latitude: coords.lat,
      longitude: coords.lng,
    }));
    setIsModalOpen(false);
  };
  const capitalizeFirstLetter = (text = "") =>
  text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();

   function handleSpecialChar(e) {
    const value = e.target.value;
    // Only allow letters and spaces
    if (/^[a-zA-Z\s]+$/.test(value)) {
      handleChange(e);
    }
  }

  function handleOnlyNumber(e) {
    const value = e.target.value;
    // Only allow numbers
    if (/^[0-9]*$/.test(value)) {
      handleChange(e);
    }
  }


  return (
    <div className="address-form-main">
      {/* LEFT SIDE - BASIC INFO CARD */}
      
 <div className="address-form">
        <h2 className="form-heading-address">Address Information</h2>

        {/* Address field full width */}
        <div className="address-row address-landmark">
          <div className="address-group">
            {/* <label>
              Address <span>*</span>
            </label> */}
            <input
              type="text"
              name="address"
              placeholder="Enter  Address"
              value={formData.address}
              onChange={handleChange}
              autoComplete="off"
              // onBlur={formik.handleBlur}
            />
            {/* {formik.touched.address && formik.errors.address && (
              <span className="error-text">{formik.errors.address}</span>
            )} */}
            {(allFieldsTouched ||
              showFieldError(touchedFields, fieldErrors, "address")) && (
              <span style={{fontSize:'0.8rem',color:'red'}}>{fieldErrors.address}</span>
            )}
          </div>
          <div className="address-group">
            {/* <label>Landmark (Optional)</label> */}
            <input
              type="text"
              name="landmark"
              placeholder="landmark (optional)"
              value={formData.landmark}
              onChange={handleSpecialChar}
              autoComplete="off"
              // onBlur={formik.handleBlur}
            />
          </div>
        </div>

        {/* State, City, Pincode, Landmark */}
        <div className="address-row state-city-pincode-landmark">
          <div className="address-group">
            {/* <label>
              State <span>*</span>
            </label> */}
            <input type="text" name="State" value={formData?.State || ''} autoComplete="off" placeholder="Enter State" onChange={handleChange}/>
          </div>

          <div className="address-group">
            {/* <label>
              City <span>*</span>
            </label> */}
            <select
              name="City"
              value={formData.City}
              onChange={handleChange}
              // onBlur={formik.handleBlur}
            >
              <option value="">Select City</option>
              <option value="Kolkata">Kolkata</option>
              <option value="Howrah">Howrah</option>
            </select>
            {/* {formik.touched.city && formik.errors.city && (
              <span className="error-text">{formik.errors.city}</span>
            )} */}
            {(allFieldsTouched ||
              showFieldError(touchedFields, fieldErrors, "City")) && (
              <span style={{fontSize:'0.8rem',color:'red'}}>{fieldErrors.City}</span>
            )}
          </div>

          <div className="address-group">
            {/* <label>
              Pincode <span>*</span>
            </label> */}
            <input
              type="text"
              name="Zipcode"
              placeholder="Pincode"
              maxLength="6"
              value={formData.Zipcode}
              onChange={handleOnlyNumber}
              autoComplete="off"
              // onChange={(e) => {
              //   const value = e.target.value.replace(/\D/g, ""); // allow only numbers
              //   formik.setFieldValue("Zipcode", value);
              // }}
              // onBlur={formik.handleBlur}
            />
            {/* {formik.touched.Zipcode && formik.errors.Zipcode && (
              <span className="error-text">{formik.errors.Zipcode}</span>
            )} */}
            {(allFieldsTouched ||
              showFieldError(touchedFields, fieldErrors, "Zipcode")) && (
              <span style={{fontSize:'0.8rem',color:'red'}}>{fieldErrors.Zipcode}</span>
            )}
          </div>
          <div className="address-group">
            <button type="button" className="" onClick={handleLocationClick}>
              <span className="btn-text" >
                <FaLocationCrosshairs />{" "}
                {currentLocation.selected
                  ? "Location Selected"
                  : "Choose location"}
                {currentLocation.selected && (
                  <span
                    style={{
                      color: "green",
                      marginLeft: 8,
                      fontWeight: 600,
                      fontSize: "1.2em",
                    }}
                  >
                    ✔
                  </span>
                )}
              </span>
            </button>
          </div>
        </div>

        {/* <div className="location-btn-row">
          <button type="button" className="location-btn" onClick={handleLocationClick}>
            📍 Set Location
          </button>
        </div> */}
      </div>
      {/* RIGHT SIDE - ADDRESS FORM */}
      <div className="basic-info-box">
  <div className="basic-info-header">
    <h3 style={{ color: "#00796b" }}>Basic Information</h3>
    <button className="edit-btn-address" onClick={onEditProfile}>
      ✏️ Edit
    </button>
  </div>

  <div className="basic-info-details">

    {/* Name */}
   <div className="info-box-address">
  <FaUser className="info-icon" />
  <span className="info-value-address">
    {capitalizeFirstLetter(formData.PFirstName)}{" "}
    {capitalizeFirstLetter(formData.PLastName)}
  </span>
</div>


    {/* Gender */}
    {formData?.PSex && (
      <div className="info-box-address">
        <IoMaleFemale className="info-icon" />
        <span className="info-value-address">
          {formData.PSex === "M" ? "Male" : "Female"}
        </span>
      </div>
    )}

    {/* Mobile */}
    {formData?.mobile_no && (
      <div className="info-box-address">
        <FaPhoneAlt className="info-icon" />
        <span className="info-value-address">{formData.mobile_no}</span>
      </div>
    )}

    {/* Date of Birth */}
    {formData?.dateofbirth && (
      <div className="info-box-address">
        <MdDateRange className="info-icon" />
        <span className="info-value-address">
          {formatDobDisplay(formData?.dateofbirth)}
        </span>
      </div>
    )}

    {/* Email */}
    {formData?.email && (
      <div className="info-box-address">
        <FaEnvelope className="info-icon" />
        <span className="info-value-address">{formData.email}</span>
      </div>
    )}

  </div>
</div>


      {isModalOpen && (
        <ModalWithMap
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onConfirm={handleLocationConfirm}
          defaultLocation={currentLocation}
        />
      )}
    </div>
  );
};

export default AddressForm;
